export default () => import(/* webpackChunkName: 'coffee/app/agreement/privacy-number' */ './PrivacyNumberAgreement');
